import styled, { css } from 'styled-components';

import type { Form } from '../../theme';
import { rem } from '../../utils/index';

type CheckboxSize = keyof typeof Form.CheckboxSize;

const getSize = ({ checkboxSize, theme }: { checkboxSize: CheckboxSize; theme: any }) =>
  rem(theme.Form.CheckboxSize[checkboxSize] || theme.Form.CheckboxSize.Medium);

export const StyledWrapper = styled.div<{
  disabled: boolean;
}>`
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;
  align-items: center;
`;

export const StyledCheckbox = styled.div<{
  checkboxSize: CheckboxSize;
  disabled: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  width: ${getSize};
  height: ${getSize};
`;

export const StyledInput = styled.input<{
  checkboxSize: CheckboxSize;
  disabled: boolean;
}>`
  appearance: none;
  width: ${getSize};
  height: ${getSize};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: ${({ theme }) => `${rem(theme.Border.Radius.XSmall)}`};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  margin: 0;
  background: ${({ theme, disabled }) =>
    disabled ? theme.Color.Neutrals.Light : theme.Color.Neutrals.Paper};
  &:checked {
    ${({ theme, disabled }) => css`
      background: ${disabled ? theme.Color.Neutrals.Border : theme.Color.NeutralsFixed.Light};
      border-color: ${disabled ? theme.Color.Neutrals.Light : theme.Color.System.Primary};
    `}
  }
`;

export const StyledCheckmark = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  position: absolute;
  pointer-events: none;
`;

export const StyledLabel = styled.div`
  margin-left: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
